export * from '@dynatrace/strato-components/styles';
